/* import __COLOCATED_TEMPLATE__ from './activators-list-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class ActivatorsListCardComponent extends Component 
{
	@service store;
	
	@tracked isAddingNewActivator = false;
	
	@tracked newActivatorName = "";
	
	@action
	selectEvent(activator,event)
	{
		activator.EventId = event;
		activator.IntermediateTimingPointId = null;
		activator.save();
	};
	
	@action
	selectTimingPoint(activator,timingPointId)
	{
		activator.IntermediateTimingPointId = timingPointId;
		activator.save();
	};
	
	@action
	saveNewActivator()
	{
		this.store.createRecord('activator',
		{
			name:this.newActivatorName,
			shouldCreateStartRecord: false,
			shouldCreateFinishRecord: false,
			shouldCreateFinishPlungerRecord: false,
			shouldCreateFinishBibRecord: false,
			shouldCreateIntermediateTimingRecord: false,
			shouldCreateFinishOnLastLap: false
		}).save();
		
		this.isAddingNewActivator = false;
		this.newActivatorName = "";
	};
	
	@action
	cancelNewActivator()
	{
		this.isAddingNewActivator = false;
		this.newActivatorName = "";
	};
	
	@action
	toggleCreateStartRecord(activator,changeEvent)
	{
		activator.shouldCreateStartRecord = changeEvent.target.checked;
		activator.save();
	};
	
	@action
	toggleCreateFinishRecord(activator,changeEvent)
	{
		activator.shouldCreateFinishRecord = changeEvent.target.checked;
		activator.save();
	};
	@action
	toggleCreateFinishRecordOff(activator,changeEvent)
	{
		activator.shouldCreateFinishRecordOff = changeEvent.target.checked;
		activator.save();
	};
	
	@action
	toggleCreateFinishPlungerRecord(activator,changeEvent)
	{
		activator.shouldCreateFinishPlungerRecord = changeEvent.target.checked;
		activator.save();
	};
	
	@action
	toggleCreateFinishBibRecord(activator,changeEvent)
	{
		activator.shouldCreateFinishBibRecord = changeEvent.target.checked;
		activator.save();
	};
	
	@action
	toggleCreateIntermediateRecord(activator,changeEvent)
	{
		activator.shouldCreateIntermediateTimingRecord = changeEvent.target.checked;
		activator.save();
	};

	@action
	toggleCreateFinishOnLastLap(activator,changeEvent)
	{
		activator.shouldCreateFinishOnLastLap = changeEvent.target.checked;
		activator.save();
	};

	@action
	deleteActivator(activator)
	{
		activator.deleteRecord();
		activator.save();
	};
};